enum NavigationTabRefs {
    ACTIVE_FOR_PERFORMER = 'active_for_performer',
    RECENTLY_CLOSED_FOR_PERFORMER = 'recently_closed_for_performer',
    ACTIVE_FOR_TEAM = 'active_for_team',
    RECENTLY_CLOSED_FOR_TEAM = 'recently_closed_for_team',
}

export default NavigationTabRefs;
